<script setup lang="ts">
import { ref, watch } from 'vue';
import type { FetchTicketResponse } from 'src/api/models';
import { parseUTCDate, combineDateWithTime, toLocalDateString } from 'src/utils/date-utc';

const props = defineProps<{
  ticket: FetchTicketResponse;
  visible: boolean;
  position: { x: number; y: number };
}>();

const emits = defineEmits<{
  close: [];
  'update:scheduled-date': [date: string];
}>();

const selectedDate = ref<Date | null>(
  props.ticket.scheduled_date ? parseUTCDate(props.ticket.scheduled_date) : null
);

watch(() => props.visible, (newVisible) => {
  if (newVisible && props.ticket.scheduled_date) {
    selectedDate.value = parseUTCDate(props.ticket.scheduled_date);
  }
});

function handleDateSelect(date: Date) {
  const newDateStr = toLocalDateString(date);
  const newScheduledDate = combineDateWithTime(newDateStr, props.ticket.scheduled_date);

  emits('update:scheduled-date', newScheduledDate);
  emits('close');
}
</script>

<template>
  <Teleport to="body">
    <div
      v-if="visible"
      class="fixed z-50"
      :style="{
        left: `${position.x}px`,
        top: `${position.y}px`
      }"
    >
      <div class="p-datepicker-panel">
        <div class="p-3 border-b border-gray-200 flex justify-between items-center">
          <span class="text-sm font-medium">Select Scheduled Date</span>
          <Button
            icon="pi pi-times"
            text
            severity="secondary"
            @click="$emit('close')"
          />
        </div>
        <DatePicker
          v-model="selectedDate"
          inline
          showIcon
          @date-select="handleDateSelect"
        />
      </div>
    </div>
  </Teleport>
</template>
